import axios from 'axios';
import { queueOfflineChange, isOnline } from './offlineStore';

export const setupOfflineInterceptor = () => {
  
  axios.interceptors.request.use(
    async (config) => {
      if (isOnline()) {
        return config;
      }

      if (config.method === 'get') {
        return config;
      }

      console.log('📱 Offline: Request in Queue', config.method, config.url);
      
      // NUR url, method und body - NICHTS anderes
      const cleanData = {
        url: config.url,
        method: config.method,
        body: config.data // das ist schon ein plain object
      };

      if (config.url.includes('/api/todos')) {
        await queueOfflineChange('todo', 'create', cleanData);
      } else if (config.url.includes('/api/protocols')) {
        await queueOfflineChange('protocol', 'create', cleanData);
      } else if (config.url.includes('/api/projects')) {
        await queueOfflineChange('project', 'create', cleanData);
      }

      return Promise.reject({
        offline: true,
        message: 'Änderung wurde offline gespeichert'
      });
    }
  );
};
